import { CurrencyIcon } from '@/components/ui/CurrencyIcon';
import { Text, Numbers } from '@/components/ui/typography';
import { fmtCurrency } from '@/lib/formatters';
import { semanticTokens } from '@packages/config/theme';
import { cn } from '@/lib/utils';

interface PortfolioHeaderProps {
  totalValue: number;
  currency?: 'USD' | 'EUR' | 'MXN' | 'BRL';
  isLive?: boolean;
}

export function PortfolioHeader({ 
  totalValue, 
  currency = 'USD',
  isLive = true
}: PortfolioHeaderProps) {
  // Use centralized formatter with Bridge API precision (truncate, not round)
  const formattedValue = fmtCurrency(totalValue, currency);

  return (
    <div 
      className={cn(
        "flex flex-col gap-6 lg:gap-8", // Revolut-style: больше белого пространства
        semanticTokens.spacing.lg
      )}
      role="region"
      aria-label="Portfolio summary"
    >
      {/* Total Portfolio Value */}
      <div className="flex flex-col gap-2">
        <Text variant="caption" color="muted">
          Total Portfolio Value
        </Text>
        <div
          className="flex items-center gap-3"
          aria-live={isLive ? "polite" : undefined}
          aria-atomic="true"
        >
          <CurrencyIcon symbol={currency} size="md" className="shrink-0" />
          <Numbers variant="display" className={semanticTokens.fg.default}>
            {formattedValue}
          </Numbers>
        </div>
      </div>
    </div>
  );
}

